import { render, staticRenderFns } from "./AddBalanceItemsToCartView.vue?vue&type=template&id=0c60fad4"
import script from "./AddBalanceItemsToCartView.vue?vue&type=script&lang=ts"
export * from "./AddBalanceItemsToCartView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports